export enum SidebarPositions {
  Start = 'Start',
  End = 'End',
}
